/**
 * UIStrings.ts
 *
 * Module for the strings to display
 */
/**
 * Localized UI strings
 */
let uIStrings;
/**
 * Set UI strings
 * @param {string} data List of localized UI strings
 */
export function setUIStrings(data) {
  uIStrings = data;
}
/**
 * Get UI strings
 * @returns the UIStrings
 */
export function getUIStrings() {
  return uIStrings;
}